import { render, staticRenderFns } from "./releases.vue?vue&type=template&id=2c2065b9&"
import script from "./releases.vue?vue&type=script&lang=js&"
export * from "./releases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports